"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ScrollSelector = void 0;
var _react = require("react");
var _debounce = _interopRequireDefault(require("lodash/debounce"));
var _ScrollSelector = _interopRequireDefault(require("./ScrollSelector.styles"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var ScrollSelector = function ScrollSelector(props) {
  var scrollOptions = props.scrollOptions,
    defaultOption = props.defaultOption,
    onScrollValueChange = props.onScrollValueChange;
  var styles = (0, _ScrollSelector.default)();
  var scrollRef = (0, _react.useRef)(null);
  var isOnScrollToValue = (0, _react.useRef)(false);

  // chrome bug while using "scrollIntoView": calling scrollIntoView() simultaneously with multiple elements doesn't work
  var scrollToValue = (0, _react.useCallback)(function (scroll, value) {
    if (scroll) {
      isOnScrollToValue.current = true;
      var selectedItem = scroll.querySelector('[data-value="' + value + '"]');
      if (selectedItem) {
        var scrollRect = scroll.getBoundingClientRect();
        var itemRect = selectedItem.getBoundingClientRect();
        var scrollHeight = scrollRect.height;
        var scrollTop = scroll.scrollTop;
        var scrollRectTop = scrollRect.top;
        var itemTop = itemRect.top;
        var itemHeight = itemRect.height;
        var delta = itemTop + itemHeight / 2 - (scrollRectTop + scrollHeight / 2);
        scroll.scroll({
          top: scrollTop + delta,
          behavior: 'smooth'
        });

        //selectedItem.scrollIntoView({ behavior: 'smooth', block: 'center'});

        isOnScrollToValue.current = false;
      }
    }
  }, []);
  var debouncedScroll = (0, _debounce.default)(function () {
    if (scrollRef.current) {
      var scrollRect = scrollRef.current.getBoundingClientRect();
      var scrollHeight = scrollRect.height;
      var scrollTop = scrollRef.current.scrollTop;
      var itemHeight = scrollHeight / 5;

      // Find the index of the middle scrolled item (or the closest one)
      var mod = scrollTop % itemHeight;
      var index = (scrollTop - mod) / itemHeight;
      if (mod > itemHeight / 2) {
        index++;
      }

      // Get the HTML item and scroll to it
      var item = scrollRef.current.querySelector('[data-index="' + Math.round(index) + '"]');
      if (item) {
        var _value = Number(item.getAttribute('data-value'));
        scrollToValue(scrollRef.current, _value);
        if (onScrollValueChange) {
          onScrollValueChange(_value);
        }
      }
    }
  }, 50);
  var handleOcScroll = function handleOcScroll() {
    if (!isOnScrollToValue.current) {
      debouncedScroll();
    }
  };
  (0, _react.useEffect)(function () {
    if (scrollRef !== null && scrollRef !== void 0 && scrollRef.current && defaultOption) {
      scrollToValue(scrollRef.current, defaultOption.value);
    }
  }, [defaultOption, scrollToValue]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: styles['cc-ScrollSelector-container'],
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      "data-testid": "cc-ScrollSelector",
      className: styles['cc-ScrollSelector'],
      ref: scrollRef,
      onScroll: function onScroll() {
        handleOcScroll();
      },
      children: scrollOptions.map(function (option, index) {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          "data-index": index,
          "data-value": option.value,
          className: styles['cc-ScrollSelector__item'],
          children: option.label
        }, option.value);
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: styles['cc-ScrollSelector__mask']
    })]
  });
};
exports.ScrollSelector = ScrollSelector;